<section *ngIf="processing">
  <h2>Processing...</h2>
  <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
  </mat-progress-bar>
</section>

<form #form="ngForm" [formGroup]="invoiceService.searchForm" class="form-field-full">
  <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
    <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
      <h2 class="noMarginHeader">
        <mat-icon>search</mat-icon> Search Invoices
      </h2>
    </div>
  </div>
  <div fxLayout="row wrap" class="matero-row">
    <div fxFlex="100.00" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>OHA Invoice Id or Invoice #</mat-label>
              <input id="id" name="id" formControlName="id" matInput />
            </mat-form-field>
          </div>

          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Organization Name</mat-label>
              <input type="text" placeholder="Search Organization" aria-label="Organization Name" matInput [formControl]="labsControl" [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let option of filteredLabs | async" [value]="option.labName">
                  {{option.labName}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>PCA</mat-label>
              <input id="pca" name="pca" formControlName="pca" matInput />
            </mat-form-field>
          </div>

          <div fxFlex="50" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Index</mat-label>
              <input id="index" name="index" formControlName="index" matInput />
            </mat-form-field>
          </div>
        </div>


        <div fxLayout="row wrap" fxLayoutGap="8px grid">
          <div fxFlex="25" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Voucher Type</mat-label>
              <mat-select id="voucherType" name="voucherType" formControlName="voucherType">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let item of voucherService.types" value="{{item}}">{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="25" fxFlex.lt-sm="100">
            <mat-form-field appearance="standard">
              <mat-label>Voucher Identifier</mat-label>
              <input id="voucherIdentifier" name="voucherIdentifier" formControlName="voucherIdentifier" matInput />
            </mat-form-field>
          </div>
          <div fxFlex="25" fxFlex.lt-sm="100" fxLayoutAlign="start center">
            <mat-checkbox formControlName="pastDue" appearance="standard">Show Past Due Only</mat-checkbox>
          </div>
          <div fxFlex="25" fxFlex.lt-sm="100" fxLayoutAlign="start center">
            <mat-form-field appearance="standard">
              <mat-label>Invoice Type</mat-label>
              <mat-select id="invoiceType" name="invoiceType" formControlName="invoiceType">
                <mat-option value=""></mat-option>
                <mat-option *ngFor="let item of invoiceService.invoiceTypes" value="{{item}}">{{item}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

      </mat-card>
    </div>
  </div>

  <!-- buttons -->
  <div fxLayout="row wrap" class="matero-row">
    <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
      <mat-card>
        <button type="submit" id="submitButtonSearch" (click)="onSubmit()" mat-raised-button color="primary" title="Search" [disabled]='processing'>Search</button>
        &nbsp;&nbsp;
        <button type="submit" id="submitButtonReset" (click)="reset()" mat-raised-button color="basic" title="Clear" [disabled]='processing'>Clear</button>
        &nbsp;&nbsp;
        <!-- <button type="submit" id="submitButtonDownload" (click)="download()" mat-raised-button color="accent"
          title="Export Search Results" [disabled]='!showResults || processing'>Export Search Results</button> -->
      </mat-card>
    </div>
  </div>
</form>

<br />

<!-- results -->
<mat-card [hidden]="!showResults">
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <strong class="noMarginHeader">Results ({{searchResultsCount}}) </strong>
    &nbsp;&nbsp;&nbsp;&nbsp;
    <mat-form-field style="width:200px;">
      <input (keyup)="filterTable($event)" placeholder="Filter results" matInput />
    </mat-form-field>
    <br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8" style="overflow-x: auto;">
      <mat-row>Results ({{searchResultsCount}}) </mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="8" fxFlex.lt-sm="100">
          <span>OHA Invoice Id</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="8" fxFlex.lt-sm="100">
          <a [routerLink]="['/invoices/edit/', result.id]" title="Edit Household {{result.id}}">{{result.id}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="invoiceNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Invoice
          Number</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.invoiceNumber}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="labName">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Organization Name</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.labName}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="pca">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">PCA</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.pca}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="index">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Index</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.index}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="invoiceType">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Invoice Type</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.invoiceType}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="voucherType">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Voucher Type</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.voucherType}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="voucherIdentifier">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Voucher
          Identifier</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.voucherIdentifier}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="dueDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Due Date</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.dueDate}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="paidDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Paid Date</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.paidDate}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="fiscalDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Fiscal Date</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.sentToFiscal}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="amountDue">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Amount Due</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          {{result.amountDue}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="paymentComplete">
        <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="15" fxFlex.lt-sm="10">Payment
          Complete</mat-header-cell>
        <mat-cell *matCellDef="let result" fxFlex="15">
          <span *ngIf="result.paymentComplete">Yes</span>
          <span *ngIf="!result.paymentComplete">No</span>
        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>